var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-custom-scrollbar",
    {
      staticClass: "workspace-module-container",
      on: { "ps-y-reach-end": _vm.scrollReachEnd }
    },
    [
      _c(
        "div",
        { attrs: { id: "projects-container" } },
        _vm._l(_vm.projectList, function(project) {
          return _c(
            "div",
            {
              staticClass: "project-preview",
              class: { "active-project": _vm.projectSelected === project.guid },
              on: {
                click: function($event) {
                  return _vm.selectProject(project.guid)
                },
                dblclick: function($event) {
                  return _vm.openProject(project.guid)
                }
              }
            },
            [
              _c("TitlePhotoForProject", {
                attrs: { dataProject: project.data_json }
              }),
              _vm._v(" "),
              project.data_json
                ? _c(
                    "div",
                    {
                      staticClass:
                        "project-preview-text-container collapsable-ellipsis"
                    },
                    [
                      _c("span", { staticClass: "project-preview-text" }, [
                        _vm._v(_vm._s(project.data_json.name))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.waitingResponseToProjectsRequest
        ? _c(
            "div",
            { staticClass: "ap-loader-grid" },
            [
              _c("SpinnerTwo"),
              _vm._v(" "),
              _c("div", { staticClass: "ap-loader-text" }, [
                _vm._v(
                  "\n                Идет загрузка проектов ...\n            "
                )
              ])
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }